module.exports = __webpack_public_path__ + "assets/img/PEDIDOSGUARDADOS.f8a1af13.svg";